import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface ProjectSummary {
  _id: string;
  name: string;
  department: string;
  status: string;
  priority: string;
  description?: string;
  deadline?: string;
  created_at?: string;
}

export function useITProjects() {
  return useQuery<ProjectSummary[]>({
    queryKey: ['it-projects'],
    queryFn: async () => {
      const res = await api.get('/api/projects');
      return res.data?.projects ?? res.data ?? [];
    },
    staleTime: 60_000,
  });
}
